import testApi from '../../service/todo.js';
const ADD_COUNT = 'ADD_COUNT';

export default {
  namespaced: true,
  state: {
    count: 0
  },
  mutations: {
    [ADD_COUNT] (state) {
      state.count = state.count + 1;
    }
  },
  actions: {
    addCount (context) {
      context.commit(ADD_COUNT);
    },
    requetTest (context) {
      testApi
        .requestTest()
        .then(function (response) {
          //  返回数据派发action
          // context.commit(USER_INFO, response)
        })
        .catch(function (error) {
           console.log(error)
        });
    }
  }
};
